import React, { useEffect, useState } from "react";

const API_BASE_URL = "";

const emptyVideo = {
  guestName: "",
  location: "",
  experience: "",
  videoUrl: "",
};

const getMediaUrl = (path) => {
  if (!path) {
    return "";
  }

  if (path.startsWith("http")) {
    return path;
  }

  if (path.startsWith("/uploads/")) {
    return `${API_BASE_URL}${path}`;
  }

  return path;
};

const TestimonialsVideos = () => {
  const [data, setData] = useState({
    videos: [],
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/testimonial-videos`
        );

        if (!response.ok) {
          throw new Error("Failed to load Testimonial Videos");
        }

        const result = await response.json();

        setData({
          videos: result.videos || [],
        });
      } catch (error) {
        console.error("Testimonial Videos fetch error:", error);

        alert("Failed to load section data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleVideoChange = (index, field, value) => {
    setData((previous) => {
      const updatedVideos = [...previous.videos];

      updatedVideos[index] = {
        ...updatedVideos[index],
        [field]: value,
      };

      return {
        ...previous,
        videos: updatedVideos,
      };
    });
  };

  const handleVideoUpload = async (index, file) => {
    if (!file) {
      return;
    }

    try {
      const token = localStorage.getItem("indiaboatsAdminToken");

      const formData = new FormData();

      formData.append("image", file);

      const response = await fetch(`${API_BASE_URL}/api/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Video upload failed");
      }

      handleVideoChange(index, "videoUrl", result.fileUrl);
    } catch (error) {
      console.error("Video upload error:", error);

      alert(error.message || "Failed to upload video");
    }
  };

  const handleAddVideo = () => {
    setData((previous) => ({
      ...previous,
      videos: [...previous.videos, { ...emptyVideo }],
    }));
  };

  const handleRemoveVideo = (index) => {
    setData((previous) => ({
      ...previous,
      videos: previous.videos.filter((_, itemIndex) => itemIndex !== index),
    }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      const token = localStorage.getItem("indiaboatsAdminToken");

      const response = await fetch(
        `${API_BASE_URL}/api/testimonial-videos`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to save changes");
      }

      setData({
        videos: result.data.videos || [],
      });

      alert("Testimonial Videos updated successfully");
    } catch (error) {
      console.error("Save error:", error);

      alert(error.message || "Failed to save changes");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="cms-page">
        <div className="cms-page-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="cms-page">
      <div className="cms-page-header">
        <div>
          <h1>Testimonials</h1>
          <p>
            Upload guest videos and edit the name and location shown on the
            homepage testimonials video card.
          </p>
        </div>

        <button
          type="button"
          className="cms-save-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>

      <div className="cms-section-card">
        <div className="cms-section-card-header">
          <h2>Video Testimonials</h2>
          <p>
            These videos appear in the left video card on the homepage
            testimonials section.
          </p>
        </div>

        <div className="cms-experience-cards">
          {data.videos.map((video, index) => (
            <div className="cms-experience-card" key={index}>
              <div className="cms-experience-card-number">
                Video {index + 1}
              </div>

              <div className="cms-form-group">
                <label>Video</label>

                <div className="cms-video-upload-box">
                  {video.videoUrl ? (
                    <video
                      className="cms-video-preview"
                      src={getMediaUrl(video.videoUrl)}
                      controls
                      muted
                    />
                  ) : (
                    <div className="cms-video-empty">No video selected</div>
                  )}

                  <div className="cms-video-upload-actions">
                    <input
                      type="file"
                      id={`testimonial-video-${index}`}
                      accept="video/mp4,video/webm,video/quicktime"
                      className="cms-file-input"
                      onChange={(e) =>
                        handleVideoUpload(index, e.target.files[0])
                      }
                    />

                    <label
                      htmlFor={`testimonial-video-${index}`}
                      className="cms-upload-btn"
                    >
                      Choose Video
                    </label>
                  </div>
                </div>

                <small>MP4, WEBM or MOV. Maximum 100MB.</small>
              </div>

              <div className="cms-form-group">
                <label>Name</label>

                <input
                  type="text"
                  value={video.guestName || ""}
                  onChange={(e) =>
                    handleVideoChange(index, "guestName", e.target.value)
                  }
                />
              </div>

              <div className="cms-form-group">
                <label>Location</label>

                <input
                  type="text"
                  value={video.location || ""}
                  onChange={(e) =>
                    handleVideoChange(index, "location", e.target.value)
                  }
                />
              </div>

              <div className="cms-form-group">
                <label>Experience</label>

                <input
                  type="text"
                  value={video.experience || ""}
                  onChange={(e) =>
                    handleVideoChange(index, "experience", e.target.value)
                  }
                />

                <small>
                  Shown next to the location on the homepage video card.
                </small>
              </div>

              <button
                type="button"
                className="cms-upload-btn"
                onClick={() => handleRemoveVideo(index)}
              >
                Remove Video
              </button>
            </div>
          ))}
        </div>

        <div className="cms-bottom-actions">
          <button
            type="button"
            className="cms-upload-btn"
            onClick={handleAddVideo}
          >
            Add Video
          </button>
        </div>
      </div>

      <div className="cms-bottom-actions">
        <button
          type="button"
          className="cms-save-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? "Saving..." : "Save Changes"}
        </button>
      </div>
    </div>
  );
};

export default TestimonialsVideos;
